import { buildDetailsUrl } from 'routing/constants'
import { filterOutEditOnlyHistories, sortSiteHistoriesInPlace } from './siteHistories'
import { resolveEditOnlyRouteIds } from './editOnlyNavigation'

export function resolveSiteHistoryId(site = {}) {
  return site.historyId ?? site.sitehistoryId ?? null
}

export function navigateDetails(history, siteId, historyId, editOnlyRoute) {
  history(buildDetailsUrl(siteId, historyId, editOnlyRoute))
}

export function navigateEditOnlySite(history, site, editOnlyRoute) {
  if (site.reassessmentFlag && !editOnlyRoute) {
    const siteId = site.siteId || site.SiteId || site.Site?.id || site.id
    return navigateDetails(history, siteId, resolveSiteHistoryId(site), editOnlyRoute)
  }
  const { siteId, editOnlySiteId } = resolveEditOnlyRouteIds(site)
  navigateDetails(history, siteId, editOnlySiteId, editOnlyRoute)
}

/** RFP default view: filter edit-only rows from history list before picking latest. */
export function createNavigateRfpStyleViewSite(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.SitesHistories?.length > 0) {
      const filtered = filterOutEditOnlyHistories(site.SitesHistories)
      if (filtered.length === 0) {
        return navigateDetails(history, site.id)
      }
      sortSiteHistoriesInPlace(filtered)
      return navigateDetails(history, site.id, filtered[0].historyId, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Uses full SitesHistories (no edit-only filter); sorts in place like original. */
export function createNavigateViewSiteWithAllHistories(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.SitesHistories?.length > 0) {
      sortSiteHistoriesInPlace(site.SitesHistories)
      return navigateDetails(history, site.id, site.SitesHistories[0].historyId, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Individual confirmed / delisted / DNQ: filter edit-only histories. */
export function createNavigateIndividualConfirmedView(site, history, editOnlySite) {
  return () => {
    if (site.SitesHistories?.length > 0) {
      const filtered = filterOutEditOnlyHistories(site.SitesHistories)
      if (filtered.length === 0) {
        return navigateDetails(history, site.id)
      }
      sortSiteHistoriesInPlace(filtered)
      return navigateDetails(history, site.id, filtered[0].historyId, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Individual role fallback viewSite (historyId || sitehistoryId when flag/edit-only). */
export function createNavigateIndividualDefaultViewSite(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.SitesHistories?.length > 0) {
      sortSiteHistoriesInPlace(site.SitesHistories)
      return navigateDetails(history, site.id, site.SitesHistories[0].historyId, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}

/** Review row: reassessment or edit-only uses history with optional editOnly route; else base details. */
export function createNavigateReviewDetails(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    if (site.reassessmentFlag) {
      return navigateDetails(history, site.id, resolveSiteHistoryId(site))
    }
    navigateDetails(history, site.id)
  }
}

/** Individual "review" when reviewed by RFP: uses site.historyId only (no sitehistoryId fallback). */
export function createNavigateIndividualReviewedByRfp(site, history, editOnlySite, editOnlySiteStatus) {
  return () => {
    if (site.reassessmentFlag || editOnlySiteStatus) {
      return navigateEditOnlySite(history, site, editOnlySite)
    }
    navigateDetails(history, site.id)
  }
}
